import { useEffect, useState, useMemo } from "react";
import {
  Container,
  ContainerView,
  ContainerRow,
} from "../../../components/Container";
import { useApp } from "../../../contexts";

import {
  formatCurrency,
  getWalletOptionDetail,
  postClaimConfirm,
  postClaimSendCode,
} from "../../../services/app";
import { useNavigate, useSearchParams } from "react-router-dom";
import { TitleWithBack } from "../../../components/Layout";
import { WithdrawFormContainer } from "../styles";
import { Body, Footer, FormButtonCancel3, FormButton2 } from "./styles";

import { AIAIcon } from "../../../components/Icons/AIAIcon";
import { error, success } from "../../../Notification";
import { getCoinCodeImage } from "../../../utils/helper";
import { useVerificationMethod } from "../../../components/ModalVerificationMethod/useVerificationMethod";

export default function WithDrawSOT(props) {
  const { T, loading, setLoading, getCurrency } = useApp();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  let { code, type } = props || {};
  if (!code && searchParams.get("code")) {
    code = searchParams.get("code");
  }
  const [claimId, setClaimId] = useState(null);
  useEffect(() => {
    if (searchParams.get("claimId")) {
      setClaimId(searchParams.get("claimId"));
    } else {
      setClaimId(null);
    }
  }, [searchParams]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [wallet, setWallet] = useState({});
  const [errors, setErrors] = useState([]);
  useEffect(() => {
    if (code) {
      loadData();
    }
  }, [code]);

  const onBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    setIsDisabled(loading);
  }, [loading]);

  const loadData = async () => {
    setLoading(true);
    let result = await getWalletOptionDetail({ code });
    if (result.status === 200) {
      const item = result?.data?.data || {};
      setWallet(item);
    }
    setLoading(false);
  };

  const currentWallet = useMemo(() => {
    return wallet;
  }, [wallet]);

  const onTransactionHistory = () => {
    navigate(`/wallet?type=option`);
  };

  const amountError = useMemo(() => {
    if (errors?.length > 0) {
      const error = errors.filter((item) => item.key === "amount");
      if (error.length > 0) {
        return error?.[0]?.value;
      }
    }
    return "";
  }, [errors]);
  const verification = useVerificationMethod();
  useEffect(() => {
    if (searchParams.get("line_connected")) {
      onSubmit({
        chooseMethod: true,
      });
      setSearchParams(
        (searchParams) => {
          searchParams.delete("line_connected");
          return searchParams;
        },
        {
          replace: true,
        }
      );
    }
  }, [searchParams]);
  const onSubmit = async (options = {}) => {
    verification.verify({
      chooseMethod: options?.chooseMethod,
      actionText: T("Claim"),
      skipTwoFa: true,
      resendEachChooseMethod: true,
      sendOtp: async (method) => {
        setLoading(true);
        try {
          const result = await postClaimSendCode({
            currencyCode: currentWallet.currencyCode,
            amount: currentWallet.claimableBalance,
            otp_method: method,
          });
          if (result.status === 200) {
            setSearchParams((prev) => {
              const newParams = new URLSearchParams(prev);
              newParams.set("claimId", result?.data?.data?.claimRequestId);
              return newParams;
            }, {
              replace: true,
            })
            return {
              success: true,
              claimId: result?.data?.data?.claimRequestId,
            }
          } else {
            setErrors(result?.data?.error?.validates || []);
            return {
              success: false,
              message:
                result?.data?.error?.message ||
                T("Failed to send OTP. Please try again later."),
            };
          }
        } catch (error) {
          console.error("Error sending OTP:", error);
          setErrors(error?.response?.data?.error?.validates || []);
          return {
            success: false,
            message:
              error?.response?.data?.error?.message ||
              T("Failed to send OTP. Please try again later."),
          };
        } finally {
          setLoading(false);
        }
      },
      action: async (method, otp, twoFa, data) => {
        try {
          setLoading(true);
          const result = await postClaimConfirm({
            currencyCode: currentWallet.currencyCode,
            claimRequestId: data?.claimId ?? claimId,
            verificationCode: otp,
            amount: currentWallet.claimableBalance,
          });
          if (result.status === 200) {
            success(
              T("Your claim request has been created and under processing.")
            );
            onTransactionHistory();
            return {
              success: true,
            };
          } else {
            const validates = result?.data?.error?.validates ?? [];
            setErrors(validates);
            if (validates.some((item) => item.key === "verificationCode")) {
              return {
                success: false,
                otpError:
                  result?.data?.error?.message ??
                  T("Invalid verification code."),
              };
            } else {
              error(
                T("Failed to create your request. Please try again later.")
              );
              return {
                success: false,
                otpError:
                  result?.data?.error?.message ??
                  T("Failed to create your request. Please try again later."),
              };
            }
          }
        } catch (error) {
          error(T("Failed to create your request. Please try again later."));
          return {
            success: false,
            otpError:
              error?.response?.data?.error?.message ||
              T("Failed to create your request. Please try again later."),
          };
        } finally {
          setLoading(false);
        }
      },
    });
  };
  const iconCurrency = useMemo(() => {
    return `/assets/images/otc/crypto/${getCoinCodeImage(
      currentWallet.currencyCode
    )?.toLowerCase()}.svg`;
  }, [currentWallet]);
  return currentWallet ? (
    <Container>
      <ContainerView>
        <TitleWithBack title={T("Claim request")} onClick={onBack} />
        <WithdrawFormContainer>
          <Body className="form">
            <div className="lg:px-3 flex flex-col gap-2">
              <div className="row-item-sot">
                <div className="text-[#818181] font-semibold font-base ">
                  {T("Recipient’s Address")}
                </div>
                <div className="border-b border-solid border-[#CCCCCC] text-black font-normal text-base font-inter pb-[10px] flex justify-start items-center gap-2">
                  <AIAIcon />{" "}
                  <span className="">{T("AI Avatar Web3 Wallet Address")}</span>
                </div>
              </div>
              <div className="row-item-sot">
                <div className="text-[#818181] font-semibold font-base ">
                  {T("Token")}
                </div>
                <div className="border-b border-solid border-[#CCCCCC] text-black font-normal text-base font-inter pb-[10px] flex justify-start items-center gap-2">
                  <img
                    alt=""
                    style={{ width: 28, height: 28 }}
                    src={iconCurrency}
                  />
                  <span className="">{currentWallet?.currencyCode}</span>
                </div>
              </div>
              <div className="row-item-sot">
                <div className="text-[#818181] font-semibold font-base ">
                  {T("Payable Amount (Only fully claim supported)")}
                </div>
                <div className="border-b border-solid border-[#CCCCCC] text-black font-normal text-base font-inter pb-[10px] flex flex-wrap justify-start items-center gap-2">
                  <span className="">
                    {formatCurrency(
                      currentWallet?.claimableBalance,
                      null,
                      getCurrency()
                    )}{" "}
                    {currentWallet?.currencyCode}
                  </span>
                  {amountError ? (
                    <div className="text-red-500 font-normal text-sm italic w-full -mt-2">
                      {T(amountError)}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div className="row-item-sot">
                <div className="text-[#818181] font-semibold font-base ">
                  {T("Gas Fee")}
                </div>
                <div className="border-b border-solid border-[#CCCCCC] text-black font-normal text-base font-inter pb-[10px] flex justify-start items-center gap-2">
                  <span className="">{T("Free")}</span>
                </div>
              </div>
            </div>
            <Footer style={{ marginTop: 0, marginLeft: 12, marginRight: 12 }}>
              <div className="flex gap-4 flex-wrap items-center">
                <FormButtonCancel3 className="flex-1" onClick={onBack}>
                  {T("Cancel")}
                </FormButtonCancel3>
                <FormButton2
                  disabled={isDisabled || loading || verification.loading}
                  className="flex-1"
                  onClick={() => onSubmit()}
                >
                  {T("Claim")}
                </FormButton2>
              </div>
            </Footer>
          </Body>
        </WithdrawFormContainer>
      </ContainerView>
    </Container>
  ) : null;
}
